/** The quick actions of the values a pre-check editor shows (a question's category, a
 *  waiver), the same on the tour record and on the operator's Pre-check-in tab. Hrefs come
 *  from gridLinks, actions from ValueActions' `act`. */
import { act, type ValueAction } from '@/components/ValueActions/ValueActions';
import { bookingsHref, cond } from '@/utils/gridLinks';

/** Waivers have no console page — the id is all there is to offer. */
export function waiverActions(waiverId: number): ValueAction[] {
  return [act.copy(String(waiverId), 'Copy waiver id')];
}

/** A tag-category question carries the category CODE only. */
export function precheckCategoryActions(code: string, ctx: { tenantId: number | null | undefined }): ValueAction[] {
  return [
    act.filter(bookingsHref([cond('category', code)], ctx.tenantId ?? null), 'Bookings with a tag in this category'),
    act.copy(code, 'Copy category code'),
  ];
}
